import { UserPreferences } from './types';

export class PatchUserPreferences {
  static readonly type = `[UserPreferences] Patch Preferences`;

  constructor(readonly payload: Partial<UserPreferences>) {}
}
